// extracted by mini-css-extract-plugin
export default {"parentBox":"BroadcastMessage_parentBox__lq+BH","broadcastHeading":"BroadcastMessage_broadcastHeading__DbMsX","broadcastContainer":"BroadcastMessage_broadcastContainer__kREPr"};